<div
	class="c-portlet-table o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary r11-datatable line-items-widget {{
		sectionclass
	}}"
	style="position: relative"
	*ngIf="showLineItems"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet__header">
		<div class="o-stack__cel">
			<div class="card-title primary-color">
				{{ sectiontitle }}
				<span *ngIf="tableConfig.enableDownload && hasData" class="datatable-icon">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon-table"
						(click)="downloadCSV($event)"
						target="_blank"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
				<ng-select
					#api
					[items]="dropdownList"
					[multiple]="dropdownSettings.multiple"
					[closeOnSelect]="dropdownSettings.closeOnSelect"
					[clearable]="dropdownSettings.clearable"
					[selectOnTab]="dropdownSettings.selectOnTab"
					[virtualScroll]="dropdownSettings.virtualScroll"
					[searchable]="dropdownSettings.searchable"
					[clearAllText]="dropdownSettings.clearAllText"
					[notFoundText]="dropdownSettings.notFoundText"
					bindLabel="lineItem"
					[compareWith]="compareItems"
					placeholder="{{ dropdownSettings.placeholder }}"
					[(ngModel)]="selectedList"
					(add)="onAdd($event)"
					(remove)="onRemove($event)"
					(close)="onClose()"
				>
					<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
						<div class="ng-value" *ngIf="items.length > 1">
							<div class="ng-value-label">{{ selectedList.length }} selected</div>
						</div>
						<div class="ng-value" *ngIf="items.length === 1">
							<div class="ng-value-label">{{ items[0].lineItem }}</div>
						</div>
					</ng-template>

					<ng-template ng-header-tmp>
						<div>
							<input
								class="dropdown-search-input"
								type="text"
								placeholder="Search"
								(input)="api.filter($event.target.value)"
							/>
						</div>
						<div *ngIf="dataTableObj.data.length > 0" class="unselect-btn-container">
							<button (click)="selectAll()" class="btn btn-sm btn-secondary">Select all</button>
							<button (click)="unselectAll()" class="btn btn-sm btn-secondary">Unselect all</button>
						</div>
						<div class="select-content">
							{{ content }}
						</div>
					</ng-template>

					<ng-template ng-option-tmp let-item="item" let-item$="item" let-index="index">
						<div class="checkbox-container">
							<input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
							<span class="checkmark"></span><span>{{ item.lineItem }}</span>
						</div>
					</ng-template>
				</ng-select>
			</div>
		</div>
	</div>
	<div class="analytics-portlet-content-table" style="padding: 0%">
		<ngx-datatable
			style="height: 100%"
			class="v5datatable"
			[columns]="dataTableObj.columns"
			[rows]="lineItemTableData"
			[offset]="currentPage"
			[sortType]="'single'"
			[cssClasses]="cssClasses"
			[columnMode]="'force'"
			[headerHeight]="50"
			[footerHeight]="footerHeight"
			[rowHeight]="rowHeight"
			[limit]="dataTableObj.limit"
			[reorderable]="reorderable"
			(activate)="onUserEvent($event)"
			[scrollbarV]="isVerticalScrollable"
			(page)="onPageChange($event)"
			(sort)="onSort($event)"
		>
			<ng-template ngFor let-column [ngForOf]="dataTableObj.columns">
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[comparator]="column.comparator"
				>
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span
							[innerHTML]="colHeader.name"
							(click)="sort()"
							style="cursor: pointer"
							*ngIf="!column.columnHasTooltip; else elseBlock"
						>
						</span>

						<ng-template #elseBlock>
							<span style="cursor: pointer">
								<span
									[innerHTML]="colHeader.name"
									(click)="sort()"
									appTooltip
									title="Tooltip"
									[title]="column.columnTooltip"
									data-size="big"
									[options]="tooltipOptions"
								>
								</span>
							</span>
						</ng-template>
					</ng-template>

					<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
						<div
							[title]="
								this.isR6
									? column.prop === 'lineItem'
										? row[column.prop] === 'Total'
											? row[column.prop]
											: row.formatted_lineItem
										: row[column.prop]
									: row[column.prop]
							"
						>
							{{ row[column.prop] }}
						</div>
					</ng-template>
				</ngx-datatable-column>
			</ng-template>
		</ngx-datatable>
	</div>
</div>
<div
	class="c-portlet-table o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary r11-datatable line-items-widget {{
		sectionclass
	}}"
	style="position: relative; display: none"
	*ngIf="!showLineItems"
>
	<div class="no-data-container">
		<h3 class="message">No Data Available</h3>
	</div>
</div>
